import { HttpClient } from '@angular/common/http';
import {
  Translation,
  TranslocoLoader,
  TranslocoModule,
  provideTransloco
} from '@ngneat/transloco';
import { Injectable, NgModule, inject, isDevMode } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string): any {
    return this.http.get<Translation>(`./assets/i18n/${lang}.json?v=` + environment.version);
  }
}

@NgModule({
  exports: [ TranslocoModule ],
  providers: [
      provideTransloco({
          config: {
            availableLangs: ['en', 'de'],
              defaultLang: 'en',
              // Remove this option if your application doesn't support changing language in runtime.
              reRenderOnLangChange: true,
              prodMode: !isDevMode(),
          },
          loader: TranslocoHttpLoader
      }),
  ],
})
export class TranslocoRootModule {}
